/**
 * FlowAI Playbook-Liste — alle Playbooks aller Workspaces.
 *
 * @page /flowai/playbooks
 * @since v2.484.0
 */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageHeader, Card, Button, Badge } from '../../components/ui';
import { IconCases } from '../../components/Icons';
import FlowAIBreadcrumb from '../../components/flowai/FlowAIBreadcrumb';

const API = import.meta.env.VITE_API_URL || '';

export default function FlowAIPlaybookList() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  useEffect(() => {
    fetch(`${API}/api/flowai/playbooks`, { credentials: 'include' })
      .then((r) => r.json())
      .then((d) => setRows(Array.isArray(d) ? d : (d?.playbooks ?? [])))
      .catch(() => setRows([]));
  }, []);
  return (
    <div className="p-6">
      <FlowAIBreadcrumb trail={[{ label: 'Playbooks' }]} />
      <PageHeader
        title="Playbooks"
        subtitle="Orchestrierte Drehbücher pro Workspace"
        actions={<Button onClick={() => navigate('/flowai/playbooks/new')}>+ Neu</Button>}
      />
      <Card padding="sm">
        {rows.length === 0 ? (
          <div className="p-12 text-center">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[var(--bg-inset,#F8F9FC)] mb-3">
              <IconCases className="w-6 h-6 text-[var(--text-tertiary,#6B7280)]" />
            </div>
            <div className="text-sm font-medium mb-1">Noch keine Playbooks</div>
            <div className="text-[12px] text-[var(--text-tertiary,#6B7280)] mb-3">Erstelle ein Playbook und verknüpfe es mit Trigger + Skills.</div>
            <Button onClick={() => navigate('/flowai/playbooks/new')}>+ Erstes Playbook anlegen</Button>
          </div>
        ) : (
          <div className="divide-y divide-[var(--border-subtle,#E5E7EB)]">
            <div className="px-3 py-2 grid grid-cols-[40px_1fr_120px_80px_180px_100px] gap-3 text-[11px] font-medium uppercase tracking-wide text-[var(--text-tertiary,#6B7280)] bg-[var(--bg-inset,#F8F9FC)]">
              <span>#</span>
              <span>Name</span>
              <span>Workspace</span>
              <span>Version</span>
              <span>Status</span>
              <span></span>
            </div>
            {rows.map((p) => (
              <div
                key={p.id}
                className="px-3 py-2.5 grid grid-cols-[40px_1fr_120px_80px_180px_100px] gap-3 items-center text-sm hover:bg-[var(--bg-inset,#F8F9FC)] cursor-pointer"
                onClick={() => navigate(`/flowai/playbooks/${p.id}`)}
              >
                <span className="font-mono text-[var(--text-tertiary,#6B7280)]">#{p.id}</span>
                <span className="font-medium truncate">{p.name}</span>
                <span className="text-[12px] text-[var(--text-tertiary,#6B7280)] truncate">{p.workspace_name || '—'}</span>
                <span className="text-[12px] text-[var(--text-secondary,#4B5563)]">{p.version ? `v${p.version}` : '—'}</span>
                <span>
                  <Badge variant={p.enabled ? 'success' : 'default'}>{p.enabled ? 'aktiv' : 'inaktiv'}</Badge>
                </span>
                <span className="text-right">
                  <Button variant="ghost" onClick={(e) => { e.stopPropagation(); navigate(`/flowai/playbooks/${p.id}`); }}>Öffnen</Button>
                </span>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
